import React, { useEffect, useState } from "react";
import "./tourmain.css";
import "./tourmain.scss";
import { motion } from "framer-motion";
import { Link, useParams } from "react-router-dom";
import truncate from "truncate-html";
import Aos from "aos";
import "aos/dist/aos.css";

const TourMain = ({ onOpenModal }) => {
  const { destination_id } = useParams();
  const [price, setPrice] = useState(500);
  const [days, setDays] = useState("any");
  const [location, setLocation] = useState("");
  const [data, setData] = useState([]);
  const [durations, setDurations] = useState([]);
  const [destinations, setDestinations] = useState([]);

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  // ✅ جلب الـ durations
  useEffect(() => {
    fetch("https://orangered-hornet-549881.hostingersite.com/api/durations")
      .then((res) => res.json())
      .then((result) => setDurations(result || []))
      .catch((err) => console.error("Error fetching durations:", err));
  }, []);

  // ✅ جلب الـ destinations
  useEffect(() => {
    fetch("https://orangered-hornet-549881.hostingersite.com/api/destinations")
      .then((res) => res.json())
      .then((result) => setDestinations(result || []))
      .catch((err) => console.error("Error fetching destinations:", err));
  }, []);

  // ✅ جلب التورز (كلها أو filtered حسب destination_id)
  useEffect(() => {
    const params = new URLSearchParams();
    if (destination_id) params.append("destination_id", destination_id);

    fetch(
      `https://orangered-hornet-549881.hostingersite.com/api/tours?${params.toString()}`
    )
      .then((res) => res.json())
      .then((result) => setData(result.data || []))
      .catch((err) => console.error("Error fetching tours:", err));
  }, [destination_id]);

  const applyFilters = () => {
    const params = new URLSearchParams();

    if (location) params.append("destination_id", location);
    if (price) params.append("max_price", price);
    if (days && days !== "any") params.append("duration_id", days);

    fetch(
      `https://orangered-hornet-549881.hostingersite.com/api/tours?${params.toString()}`
    )
      .then((res) => res.json())
      .then((result) => setData(result.data || []))
      .catch((err) => console.error("Error fetching filtered tours:", err));
  };

  return (
    <section className="tourmain tourcontainer tour-section">
      {/* 🔍 Filters */}
      <div className="filter-tour-section">
        <motion.div className="formBox" animate={{ opacity: 1, y: 0 }}>
          <h2 className="filterTitle">🔍 Find Your Perfect Trip</h2>

          <div className="filter-row">
            {/* Destination */}
            <div className="filter-group">
              <label>Destination</label>
              <select
                value={location}
                onChange={(e) => setLocation(e.target.value)}
              >
                <option value="">Select Location</option>
                {destinations.map((dest) => (
                  <option key={dest.id} value={dest.id}>
                    {dest.title}
                  </option>
                ))}
              </select>
            </div>

            {/* Price */}
            <div className="filter-group">
              <label>Max Budget: ${price}</label>
              <input
                type="range"
                min="10"
                max="5000"
                step="10"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
              />
            </div>

            {/* Days */}
            <div className="filter-group">
              <label>Duration</label>
              <select value={days} onChange={(e) => setDays(e.target.value)}>
                <option value="any">Any</option>
                {durations.map((d) => (
                  <option key={d.id} value={d.id}>
                    {d.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Button */}
          <div className="text-center">
            <button className="submitBtn" onClick={applyFilters}>
              Apply Filters
            </button>
          </div>
        </motion.div>
      </div>

      {/* Title */}
      <div className="secTitle">
        <span>Top Rated Tours</span>
        <h2 className="title">Best Holidays and Vacations to Egypt</h2>
        <p>
          Discover our best Egypt travel categories for Egypt trips to create
          your best Egypt tour plan.
        </p>
      </div>

      {/* Tours Grid */}
      <div className="secContent grid">
        {data.length > 0 ? (
          data.map((trip) => {
            const firstImage = trip.images?.length
              ? `https://orangered-hornet-549881.hostingersite.com/storage/${trip.images[0]}`
              : "https://via.placeholder.com/400x250";

            return (
              <div key={trip.id} className="tourCard">
                <div className="tourImage">
                  <img src={firstImage} alt={trip.title} />
                  <span className="priceTag">
                    From:{" "}
                    {trip.pricings?.length > 0
                      ? Math.min(
                          ...trip.pricings.map((p) =>
                            parseFloat(p.price_per_person)
                          )
                        )
                      : "N/A"}
                    $
                  </span>
                </div>

                <div className="tourContent">
                  <h3 className="tourTitle">{trip.title}</h3>
                  <p
                    className="tourDesc"
                    dangerouslySetInnerHTML={{
                      __html: trip.description
                        ? truncate(trip.description, 80)
                        : "",
                    }}
                  />
                  <Link to={`/tour-details/${trip.id}`}>
                    <button className="bookBtn">TOUR DETAILS</button>
                  </Link>
                </div>
              </div>
            );
          })
        ) : (
          <p>Loading...</p>
        )}
      </div>

      {/* Offer Section */}
      <div className="offer-one-tour-main">
        <div className="offer-content">
          <h1>Make your Ideal Egypt Itinerary Now!</h1>
          <span className="offer-content-h3">
            Tailor Made Your Egypt Trips
          </span>
          <div className="tailor-made_spo d-grid_spo">
            <a
              href="#"
              className="theme-btn btn-style-three-spo"
              onClick={(e) => {
                e.preventDefault();
                onOpenModal();
              }}
            >
              Design Your Perfect Egypt Tour Now
            </a>
          </div>
        </div>
      </div>
  

   {/* <div className="secContent grid">
        {data.length > 0 ? (
          data.map((trip) => {
            const firstImage = trip.images?.length
              ? `https://orangered-hornet-549881.hostingersite.com/storage/${trip.images[0]}`
              : "https://via.placeholder.com/400x250";

            return (
              <div key={trip.id} className="tourCard">
                <div className="tourImage">
                  <img src={firstImage} alt={trip.title} />
                  <span className="priceTag">
                    From:{" "}
                    {trip.pricings?.length > 0
                      ? Math.min(
                          ...trip.pricings.map((p) =>
                            parseFloat(p.price_per_person)
                          )
                        )
                      : "N/A"}
                    $
                  </span>
                </div>

                <div className="tourContent">
                  <h3 className="tourTitle">{trip.title}</h3>
                  <p
                    className="tourDesc"
                    dangerouslySetInnerHTML={{
                      __html: trip.description
                        ? truncate(trip.description, 80)
                        : "",
                    }}
                  />
                  <Link to={`/tour-details/${trip.id}`}>
                    <button className="bookBtn">TOUR DETAILS</button>
                  </Link>
                </div>
              </div>
            );
          })
        ) : (
          <p>Loading...</p>
        )}
      </div> */}
    </section>

    
  );
};

export default TourMain;
